$(function() {

  // tooltip
  // $('[data-toggle="tooltip"]').tooltip();

  //popover
  var hasTapEvent = ('ontouchstart' in window);
  if(hasTapEvent) {
    $('[data-toggle="popover"]').popover();
  } else {
    $('[data-toggle="popover"]').popover({trigger: 'hover'});
  }

  // bslider
  $('[data-toggle="bslider"]').bslider();

  // datetimepicker
  $('[data-toggle="datetimepicker"]').datetimepicker({
    dayViewHeaderFormat: 'YYYY/MM',
    format: 'YYYY/MM/DD',
    locale: 'ja'
  });

  //住所自動入力
  $('.js-zip-check').on('click',function(event) {
    event.preventDefault();
    AjaxZip3.zip2addr('zipCode','','prefectureCode','address');
  });

  //日付データ入力
  $('[data-toggle="datetimepicker"]').each(function(index, el) {
    if($(el).attr('name') == 'deliveryDate') {
      var m = moment().add(11, 'days');
      var date = m.format("YYYY/MM/DD");
      $(el).val(date);
    }
  });

  //その他の選択肢
  $('.js-radio-other').each(function(index, el) {
    var name = $(el).find('input').attr('name');
    var other = $(el).find('input');
    $('input[name="'+name+'"]').on('change', function(event) {
      event.preventDefault();
      if($(other).is(':checked')) {
        $(el).addClass('is-checked');
      } else {
        $(el).removeClass('is-checked');
      }
    });
  });

  //ラジオボックスの状態クラス追加
  $('.nu-radio-list').each(function(index, element) {
    var name = $(element).find('input').attr('name');
    var $inputs = $(element).find('input[name="'+name+'"]');
    function update(name) {
      var $inputs = $('input[name="'+name+'"]');
      $inputs.each(function(i, el) {
        if($(el).is(':checked')) {
          $(el).closest('.nu-checkbox-collapse').addClass('is-checked');
          $(el).closest('.nu-checkbox').addClass('is-checked');
          $(el).closest('.nu-radio').addClass('is-checked');
        } else {
          $(el).closest('.nu-checkbox-collapse').removeClass('is-checked');
          $(el).closest('.nu-checkbox').removeClass('is-checked');
          $(el).closest('.nu-radio').removeClass('is-checked');
        }

        if($(el).is(':disabled') == true) {
          $(el).closest('.nu-checkbox').addClass('is-disabled');
          $(el).closest('.nu-radio').addClass('is-disabled');
        } else {
          $(el).closest('.nu-checkbox').removeClass('is-disabled');
          $(el).closest('.nu-radio').removeClass('is-disabled');
        }
      });
    }
    $inputs.on('change', function(event) {
      update($(event.currentTarget).attr('name'));
    });
    update();
  });

  //入力例の入力
  $('.js-copy-example').each(function(index, el) {
    $(el).on('click', function(event) {
      event.preventDefault();
      var target = $(this).attr('data-target');
      var example = $(this).closest('.modal-body').find('.example').text();
      $(target).val(example);
      $(this).closest('.modal').modal('hide');
    });
  });

  //スクロールについてくるタイトル
  $('.js-scroll-follow').each(function(index, el) {
    var $fieldset = $(el).closest('fieldset');
    var legendHeight = $(el).height() + 20;
    $(el).parent('.col-sm-3').css({height: legendHeight+"px"});
    $fieldset.waypoint({
      handler: function(direction) {
        if(direction == 'down') {
          $(el).addClass('is-fixed-sm');
        } else {
          $(el).removeClass('is-fixed-sm');
        }
      }
    })
    $fieldset.waypoint({
      handler: function(direction) {
        if(direction == 'up') {
          $(el).addClass('is-fixed-sm');
        } else {
          $(el).removeClass('is-fixed-sm');
        }
      },
      offset: -$fieldset.height() + legendHeight - 10
    })
  });

  //使用する素材
  $('.js-collapse-outcloth').each(function(index, element) {
    var name = $(element).attr('href');
    var $result = $(name+'-result');
    var $target = $(name);
    // $target.on('show.bs.collapse', function () {
    //   $result.addClass('is-open');
    // });
    // $target.on('hide.bs.collapse', function () {
    //   $result.removeClass('is-open');
    // });
    $target.find('.nu-radio__other').find('input').on('keyup', function(event) {
      update();
    });
    $target.find('input').on('change', function(event) {
      update();
    });
    update();

    function update() {
      var name = $target.find('input:first-child').attr('name');
      var values = $('input[name="'+name+'"]:checked').map(function() {
        return $(this).closest('label')[0].innerText;
      }).get();

      if(values[0] && values[0].indexOf('不明') != -1) {
        var t = $target.find('.nu-radio__other').find('input').val();
        if(t.length > 0) {
          values[0] += '（'+t+'）';
        }
      }
      var text = values.join(', ');

      $target.find('[data-toggle="bslider"]').each(function(index, el) {
        var val = $(el).val();
        if(index == 0) {
          text += '　厚さ:';
        } else if(index == 1) {
          text += ', 伸縮性:';
        } else {
          text += ', 手触り:';
        }
        text += val;
      });
      if(values.length == 0) {
        text = '未選択';
        $result.addClass('is-empty');
      } else {
        $result.removeClass('is-empty');
      }
      $result.text(text);
    }
  });

  //nu-order-block
  $('.nu-order-block').each(function(index, el) {
    var $link = $(el).find('.nu-order-block__trigger a');
    var $content = $(el).find('.nu-order-block__content');
    $link.on('click', function(event) {
      var isOpen = $content.hasClass('in');
      if(isOpen == true) {
        $(el).removeClass('is-open');
      } else {
        $(el).addClass('is-open');
      }
    });
  });

  // //パターン有無のコンテンツ切り替え
  // $('input[name="has_pattern"]').on('change', function(event) {
  //   updateHasPattern();
  // });
  // function updateHasPattern() {
  //   var $active = $('input[name="has_pattern"]:checked');
  //   $('.has_pattern').each(function(index, el) {
  //     if($(el).hasClass($active.attr('data-target')) == true) {
  //       $(el).removeClass('is-hidden');
  //     } else {
  //       $(el).addClass('is-hidden');
  //     }
  //   });
  // }
  // updateHasPattern();

  //パターン無のコンテンツ切り替え
  $('input[name="without_pattern"]').on('change', function(event) {
    updateWithoutPattern();
  });
  function updateWithoutPattern() {
    $('input[name="without_pattern"]').each(function(index, el) {
      var $target = $('.'+$(el).attr('data-target'));
      if($(el).prop('checked') == true) {
        $target.removeClass('is-hidden');
      } else {
        $target.addClass('is-hidden');
      }
    });
  }
  updateWithoutPattern();

});
